import { render } from "./ShouRuXingCaiPage1.vue?vue&type=template&id=fc8ca5b0&scoped=true"
import script from "./ShouRuXingCaiPage1.vue?vue&type=script&lang=js"
export * from "./ShouRuXingCaiPage1.vue?vue&type=script&lang=js"

import "./ShouRuXingCaiPage1.vue?vue&type=style&index=0&id=fc8ca5b0&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fc8ca5b0"]])

export default __exports__